// extracted by mini-css-extract-plugin
export default {"noteCreatingActions":"EditNoteForm_noteCreatingActions__dlJoy","noteCreatingDeleteAction":"EditNoteForm_noteCreatingDeleteAction__xiCBW"};